var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPrint = function SvgPrint(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8222 7.32315H22.8525V1.92139C22.8525 1.40596 22.4347 0.988037 21.9192 0.988037H6.08081C5.56538 0.988037 5.14746 1.4059 5.14746 1.92139V7.32315H2.17777C0.976937 7.32315 0 8.30014 0 9.50097V18.8909C0 20.0917 0.976937 21.0687 2.17777 21.0687H5.14762V26.0788C5.14762 26.5943 5.56549 27.0122 6.08098 27.0122H21.919C22.4345 27.0122 22.8524 26.5943 22.8524 26.0788V21.0687H25.8222C27.0231 21.0687 28 20.0917 28 18.8909V9.50097C28 8.30019 27.0231 7.32315 25.8222 7.32315ZM7.01411 2.85474H20.9858V7.32315H7.01411V2.85474ZM20.9857 25.1455H7.01433C7.01433 24.9631 7.01433 17.7352 7.01433 17.5096H20.9857C20.9857 17.7408 20.9857 24.9701 20.9857 25.1455ZM21.9192 12.8037H19.5434C19.028 12.8037 18.61 12.3858 18.61 11.8703C18.61 11.3548 19.0279 10.937 19.5434 10.937H21.9192C22.4346 10.937 22.8525 11.3548 22.8525 11.8703C22.8525 12.3858 22.4347 12.8037 21.9192 12.8037Z",
    fill: "#3F4857"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrint, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/print.4f8c4d19.svg";
export { ForwardRef as ReactComponent };